import { createContext, useContext } from 'react';

// Exclusivement les réponses des API publiques anonymes, jamais un profil.
export const PublicPageDataContext = createContext(null);

export function readPublicPageData() {
  if (typeof window === 'undefined') return null;
  const data = window.__WM_PUBLIC_PAGE__;
  return data?.path === window.location.pathname.replace(/\/+$/, '') ? data : null;
}

export function usePublicPageData() {
  return useContext(PublicPageDataContext) || readPublicPageData();
}
